/**
 * @generated SignedSource<<9dd3de8f982dc218b25c85e651586f79>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type taskApprover_softwareReleasesApprovers_jiraVersion$data = {
  readonly " $fragmentSpreads": FragmentRefs<"approvalDrawer_softwareReleasesApprovers_jiraVersion">;
  readonly " $fragmentType": "taskApprover_softwareReleasesApprovers_jiraVersion";
};
export type taskApprover_softwareReleasesApprovers_jiraVersion$key = {
  readonly " $data"?: taskApprover_softwareReleasesApprovers_jiraVersion$data;
  readonly " $fragmentSpreads": FragmentRefs<"taskApprover_softwareReleasesApprovers_jiraVersion">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "taskApprover_softwareReleasesApprovers_jiraVersion",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "approvalDrawer_softwareReleasesApprovers_jiraVersion"
    }
  ],
  "type": "JiraVersion"
};

(node as any).hash = "70db2f75a58a67028506d4a771e78c7c";

export default node;
